// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__JtG2X","logo":"Header_logo__YS_nb","container":"Header_container__zKAal","navigation":"Header_navigation__XAoBE"};